const asset = (name) => `/generated/${name}.png`;

export const BLOG_POSTS = [
  {
    id: "b1",
    title: "The Complete Guide to Post-Renovation Cleaning in Singapore",
    slug: "post-renovation-cleaning-guide",
    excerpt:
      "Renovation dust is finer than you think. Here's how to properly clean a newly renovated Singapore home before you move in.",
    content: `Renovation dust doesn't just sit on surfaces — it settles inside cabinetry joinery, air-con grilles and the tiniest gaps. In this guide we'll walk through the exact process our team uses to deliver a properly clean, dust-free finish after renovation.

## Why Post-Renovation Cleaning Matters

Fine cement and gypsum dust can irritate lungs and sinuses. It also settles on newly installed carpentry, causing surface hazing and premature dulling of finishes.

## What a Professional Job Looks Like

1. HEPA vacuum every horizontal and vertical surface.
2. Detail wipe every inch of carpentry inside and out.
3. Remove paint spots and cement marks from tiles, glass and fixtures.
4. Clean window grilles, tracks and sliding-door rails.
5. A final dust-free walk-through.

## When to Book

Book once heavy debris has been removed by the contractor — usually 1–3 days after completion. This gives dust time to settle so we can lift it all at once.`,
    featuredImage: asset("service_post_reno"),
    imageAltText: "Emilio's Solutions team cleaning a renovated Singapore condo kitchen",
    category: "Cleaning Guides",
    author: "Emilio's Solutions Team",
    publishedAt: "2026-01-12",
    readingTime: 6,
    featured: true,
    status: "published",
  },
  {
    id: "b2",
    title: "End-of-Tenancy Cleaning: Getting Your Deposit Back",
    slug: "end-of-tenancy-deposit",
    excerpt:
      "A structured end-of-tenancy clean gives you the best shot at a smooth handover — and a full deposit refund.",
    content: `Every landlord walks into an empty unit expecting the same thing: a property returned as it was received, minus fair wear-and-tear. Cleanliness is the single most common friction point at handover.

## A Realistic Handover Checklist

- Kitchen degrease including hood, hob and behind appliances
- Bathroom scale removal and grout detail
- Interior of built-ins wiped
- Windows and sliding doors cleaned
- Floors vacuumed and mopped
- Cobweb detail on ceilings and corners

## The Faster Route

Most tenants underestimate the effort. A professional end-of-tenancy service delivers all of the above in a single visit — usually faster than a DIY weekend.`,
    featuredImage: asset("service_end_tenancy"),
    imageAltText: "Empty apartment prepared for handover",
    category: "Tenancy",
    author: "Emilio's Solutions Team",
    publishedAt: "2026-01-05",
    readingTime: 5,
    featured: false,
    status: "published",
  },
  {
    id: "b3",
    title: "Caring for Your Mattress and Sofa: A Long-Term View",
    slug: "mattress-sofa-care",
    excerpt:
      "Small habits and periodic deep cleans extend the life of your upholstery — and your family's air quality.",
    content: `Mattresses and sofas absorb everything: dust, dead skin, oils, spills. A regular light routine plus a periodic professional clean makes a real difference.

## Weekly Routine

Vacuum both mattress and sofa surfaces with an upholstery attachment. Rotate mattresses monthly where possible.

## Every 6–12 Months

Book a professional upholstery extraction. Our low-moisture process refreshes fibres without over-wetting.`,
    featuredImage: asset("service_mattress"),
    imageAltText: "Professional mattress vacuum extraction",
    category: "Home Care",
    author: "Emilio's Solutions Team",
    publishedAt: "2025-12-20",
    readingTime: 4,
    featured: false,
    status: "published",
  },
];

export const BLOG_CATEGORIES = [
  "All",
  "Cleaning Guides",
  "Tenancy",
  "Home Care",
  "Commercial",
];

export const getPostBySlug = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
